import { Radius } from "@mui/material/styles/createTheme";

export const createRadius =
  (radiusInput = 8): Radius =>
  (value?: number): string =>
    (value !== undefined ? value * radiusInput : radiusInput) + "px";

export const radius = createRadius(8);
